import React from 'react';
import { Badge } from '../..';

function StatusIndicator({ status, label }) {
	if (status === "approved") {
		return <Badge variant="success">{label || "Approved"}</Badge>;
	}
	if (status === "booked") {
		return <Badge variant="success">{label || "Booked"}</Badge>;
	}
	if (status === "rejected") {
		return <Badge variant="danger">{label || "Rejected"}</Badge>;
	}
	if (status === "pending") {
		return <Badge variant="warning">{label || "Pending"}</Badge>;
	}
	return null;
}

export default StatusIndicator;